import { compose, applyMiddleware, createStore} from 'redux';
import { combineReducers } from 'redux-immutable';
import thunk from 'redux-thunk';

import { actionTypes as peopleActionTypes, reducer as peopleReducer } from 'modules/people';
import { actionTypes as siteActionTypes, reducer as siteReducer } from 'modules/site';

const commonReducers = {
    people: peopleReducer,
    site: siteReducer
};

const actionTypes = Object.assign(
    {},
    peopleActionTypes,
    siteActionTypes
);

const configure = (initialState) => {
    const enhanceCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const store = createStore(
        combineReducers(commonReducers),
        initialState,
        // connect to Redux Dev Tools extension for investigating the store in development
        enhanceCompose(applyMiddleware(thunk))
    );
    store.reducers = commonReducers;
    store.injectReducer = (name, asyncReducer) => {
        if (Object.prototype.hasOwnProperty.call(store.reducers, name)) {
            throw Error(`${name} already exists in reducers.`);
        }
        Object.defineProperty(store.reducers, name, {
            writable: false,
            configurable: false,
            enumerable: true,
            value: asyncReducer
        });
        store.replaceReducer(combineReducers(store.reducers));
    };
    return store;
};

export default { configure, actionTypes };



// WEBPACK FOOTER //
// ./source/modules/base/store.js